import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { withTheme } from "@material-ui/styles";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

import { responsiveThemeGrid } from "../layout/Grid";
import { SectionTitle } from "../pages/VehicleInfoPage";

const GroupedAccessories = withTheme(
  styled.div`
    ${responsiveThemeGrid}
  `
);

const GroupedAccessory = styled(RadioGroup)``;

const SingleAccessories = withTheme(styled.div`
  ${responsiveThemeGrid}
`);

const SingleAccessory = styled(FormControlLabel)`
  width: 100%;
`;

const AccessoryCheckBoxes = ({ items, onChange, value, name, ...props }) => {
  if (items.length < 1) {
    return null;
  }

  const accessories = Array.from(
    items.reduce((groups, accessory) => {
      const { group } = accessory;
      if (groups.has(group)) {
        groups.get(group).push(accessory);
      } else {
        groups.set(group, [accessory]);
      }
      return groups;
    }, new Map())
  );

  const groupedAccessories = accessories.filter(
    ([, items]) => items.length > 1
  );
  const singleAccessories = accessories.filter(
    ([, items]) => items.length === 1
  );

  const handleCheckboxChange = (groupName) => (evt) => {
    const { target } = evt;
    const newValue = {
      ...value,
      [groupName]: target.checked ? target.id : undefined,
    };
    onChange({ target: { name, value: newValue } });
  };

  const handleRadioChange = (groupName) => (evt) => {
    const { target } = evt;
    const newValue = { ...value, [groupName]: target.value };
    onChange({ target: { name, value: newValue } });
  };

  return (
    <FormControl component="fieldset" {...props}>
      <SectionTitle component="legend">
        Does your car have any accessories?
      </SectionTitle>
      <FormGroup>
        <SingleAccessories>
          {singleAccessories.map(([groupName, accessories]) => (
            <SingleAccessory
              key={accessories[0].id}
              control={
                <Checkbox
                  id={accessories[0].id}
                  checked={!!value[groupName]}
                  value={accessories[0].id}
                  onChange={handleCheckboxChange(groupName)}
                />
              }
              label={accessories[0].description}
            />
          ))}
        </SingleAccessories>
        <GroupedAccessories>
          {groupedAccessories.map(([groupName, accessories]) => (
            <GroupedAccessory
              aria-label="Pick from the following accessories"
              name={groupName}
              value={value[groupName]}
              onChange={handleRadioChange(groupName)}
            >
              <FormLabel component="legend">Pick one</FormLabel>
              {accessories.map(({ id, description }) => (
                <FormControlLabel
                  key={id}
                  value={id}
                  control={<Radio />}
                  label={description}
                />
              ))}
            </GroupedAccessory>
          ))}
        </GroupedAccessories>
      </FormGroup>
    </FormControl>
  );
};

AccessoryCheckBoxes.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      group: PropTypes.string,
      id: PropTypes.string,
      tradeInValue: PropTypes.number,
    })
  ),
  value: PropTypes.object,
};

AccessoryCheckBoxes.defaultProps = {
  items: [],
  value: {},
};

export default AccessoryCheckBoxes;
